import {
    useMemo,
    type FC
} from "react";
import {
    Animated
} from "react-native";
import type IDisclosureChevronProps from "./type";
import stylesheet from "./stylesheet";
import {
    useAnimatedState
} from "../../../../helpers/motion";
import {
    ChevronDown as ChevronDownIcon
} from "lucide-react-native";

const DisclosureChevron: FC<IDisclosureChevronProps> = ({
    customTheme,
    isOpen,
    color,
    style,
    size
}) => {
    const progress = useAnimatedState({
        intent: isOpen ? "expand" : "collapse",
        value: isOpen ? 1 : 0,
        customTheme
    });

    const rotate = useMemo(() => progress.interpolate({
        outputRange: [
            "0deg",
            "180deg"
        ],
        inputRange: [
            0,
            1
        ]
    }), [
        progress
    ]);

    return <Animated.View
        style={[
            style,
            stylesheet.container,
            {
                transform: [
                    {
                        rotate
                    }
                ]
            }
        ]}
        aria-hidden={true}
    >
        <ChevronDownIcon
            color={color}
            size={size}
        />
    </Animated.View>;
};
export default DisclosureChevron;
